<template>
  <section id="timeline-section" class="px3 py4">
    <h1 class="center m0 mb3" v-html="content.title"></h1>
    <section class="flex flex-wrap mt3">
      <div class="event pr2" v-for="item in events" :key="item.id">
        <article class="py2" @click="showDescr($event, item.id)">
          <div class="mb1 flex justify-between">
            <span class="h3 mb1 bold" v-html="formatDate(item.date)"></span>
            <span class v-if="item.body && item.body.length > 0">
              <span v-if="item.isActive" class="icon-size">&ndash;</span>
              <span v-else class="blue icon-size">+</span>
            </span>
          </div>
          <span class="h4 dark-grey" v-if="item.location" v-html="item.location"></span>
          <p class="h4 m0 mb1 regular" v-html="item.title"></p>
          <div v-if="item.isActive && item.body.length > 0" class="h5 mt3" v-html="item.body"></div>
        </article>
      </div>
    </section>
  </section>
</template>

<script>
export default {
  props: ['lang'],

  created: function () {
    this.init()
  },

  watch: {
    '$route' (to, from) {
      if (from.params.lang !== to.params.lang) {
        this.init()
      }
    }
  },

  data () {
    return {
      content: {},
      events: [],
      eventsByYear: {}
    }
  },

  methods: {
    init: function () {
      this.lang = this.lang || this.$route.params.lang || this.defineDefaultLang()
      // loadContent is a global helper method
      this.content = this.loadContent(this.lang, 'timeline')
      let url = this.getContentAPIBase() + '/events?public=true&language.code=' + this.lang

      fetch(url).then((response) => {
        return response.json()
      }).then((data) => {
        this.events = data
        this.sortByDate(this.events)
        for (let e of data) {
          e.title = window.marked.parse(e.title)
          if (e.lede) {
            e.lede = window.marked.parse(e.lede)
          }
          if (e.body) {
            e.body = window.marked.parse(e.body)
          }
          e.isActive = false
        }
      }).catch((err) => {
        console.error('fetch error', err)
      })
    },

    sortByDate (events) {
      events.sort(function (a, b) {
        a = new Date(a.date)
        b = new Date(b.date)
        return a > b ? -1 : a < b ? 1 : 0
      })
    },

    showDescr (event, id) {
      // NOTE: the caveat about reactivity of lists, see more https://vuejs.org/v2/guide/list.html#Caveats
      let events = []
      for (let item of this.events) {
        if (item.id === id) {
          if (!item.isActive) {
            item.isActive = true
          } else {
            item.isActive = false
          }
        } else {
          item.isActive = false
        }
        events.push(item)
      }
      this.events = events
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/colors";

article {
  transition: all 0.2s ease-in;
  height: 100%;
  border-top: 1px lighten($dark-grey, 35%) solid;

  &:hover,
  &:focus {
    // background-color: $light-grey;
    cursor: pointer;
    & .h3 {
      color: $blue;
      transition: all 0.2s ease-in;
    }

    border-color: $blue;
  }
}

.event {
  flex-basis: 17.75em;

  @media (max-width: 915px) {
    flex-basis: 100%;
  }
}

.icon-size {
  font-size: 1.5em;
  line-height: 1.175em;
}
</style>



// WEBPACK FOOTER //
// Timeline.vue?156017a3